import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const [FormFieldContextProvider, useFormFieldContext] = buildGlobalReferenceContext("FormFieldRoot", {
  state: "default",
  required: false,
  disabled: false
});

export { FormFieldContextProvider, useFormFieldContext };
//# sourceMappingURL=context.mjs.map
